import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../types/actionParams';
import { FlowDraftAllowedActions } from '../types/FlowDraftAllowedActions';

export class GetFlowDraftActionsRequest extends Request<ISingleIdParams, FlowDraftAllowedActions> {
 constructor(id: string) {
   super('getFlowDraftActions', { id: id });
 }
}